import { MEDIA } from "@/mocks/media";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotMedia from "./components/HotMedia";
import NewsBrief from "./components/NewsBrief";
import SiteIntroBand from "./components/SiteIntroBand";

export default function Home() {
  usePageMeta({
    title: "WWW.17C - 综合影视内容平台与最新影视资讯",
    description:
      "WWW.17C为您提供丰富的电影、电视剧、综艺等影视资源和最新资讯，涵盖多种类型，方便用户了解和浏览各类影视内容。",
    keywords: "WWW.17C,影视平台,电影资源,电视剧更新,影视资讯,影视浏览",
  });

  const featured = MEDIA.filter((item) => item.featured).slice(0, 5);

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-8 md:py-8">
      <h1 className="sr-only">WWW.17C 综合影视内容平台</h1>
      <HeroCarousel items={featured} />
      <div className="mt-12 space-y-14 md:mt-14">
        <CategoryEntries />
        <HotMedia />
        <NewsBrief />
        <SiteIntroBand />
      </div>
    </div>
  );
}